<template>
    <div class="sub-assignments">
        <div
            class="sub-assignment-page-list"
            v-for="page in subAssignmentIn.pages"
            :key="page.id">
            <div
                v-for="part in page.parts"
                :class="part.type === 1 ? 'sub-assignment-explanation' : 'sub-assignment'"
                :key="part.id">
                <design-2021-assignment-show-explanation-part-component
                    v-if="part.isExplanation()"
                    :part-in="part">
                </design-2021-assignment-show-explanation-part-component>

                <design-2021-assignment-show-assignment-part-component
                    v-if="part.isAssignment()"
                    :profile-categories-in="profileCategoriesIn"
                    :part-in="part"
                    :group-type-id-in="groupTypeIdIn"
                    :is-example-in="isExampleIn"
                    :is-coop-in="isCoop"
                    :can-answer="canAnswer"
                    :project-id="projectId">
                </design-2021-assignment-show-assignment-part-component>
            </div>
        </div>

        <div
            class="sub-assignments-submit"
            v-if="subAssignmentIn.onlyExplanation()">
            <design-2021-assignment-show-sub-assignment-submit-component
                v-if="canSubmitExplanation"
                :assignment-in="assignmentIn"
                :sub-assignment-in="subAssignmentIn"
                :project-id="projectId"
                :assignment-status-in="assignmentStatusIn"
                @submitted="submitted('only_explanation')"
                type-in="only_explanation">
            </design-2021-assignment-show-sub-assignment-submit-component>
        </div>

        <div
            class="sub-assignments-submit"
            v-if="subAssignmentIn.hasPartWithTypeAssignment()">
            <design-2021-assignment-show-sub-assignment-submit-component
                v-if="canSubmitAssignment"
                :assignment-in="assignmentIn"
                :sub-assignment-in="subAssignmentIn"
                :project-id="projectId"
                :assignment-status-in="assignmentStatusIn"
                @submitted="submitted('assignment')"
                type-in="assignment">
            </design-2021-assignment-show-sub-assignment-submit-component>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-assignment-show-sub-assignment-list-view-component',
    props: [
        'assignmentIn',
        'subAssignmentIn',
        'canAnswer',
        'projectId',
        'assignmentStatusIn',
        'profileCategoriesIn',
        'isExampleIn',
        'groupTypeIdIn',
    ],
    methods: {
        submitted(type) {
            this.$emit('submitted', type);
        },
        canAddToProfile(container) {
            if (!this.projectId) {
                return false;
            }

            return (
                (this.$authUser.isStudent() || this.$authUser.isAdmin()) &&
                container.type === 2 &&
                (container.parts[0].isAssignmentFileUpload() || container.parts[0].isAssignmentEditor()) &&
                container.parts[0].hasAnswer() &&
                container.parts[0].getAnswer().files.length
            );
        },
    },
    computed: {
        isCoop() {
            if (this.assignmentIn.assignment_cooperations.length) {
                return true;
            }
            if (this.subAssignmentIn.assignment_cooperations.length) {
                return true;
            }
            return false;
        },
        canSubmitAssignment() {
            if (!this.projectId) {
                return false;
            }

            if (!this.subAssignmentIn.hasPartWithTypeAssignment()) {
                return false;
            }

            return !this.subAssignmentIn.hasStatus() || this.subAssignmentIn.getStatus().isWaitingForSubmit();
        },

        canSubmitExplanation() {
            if (
                !this.projectId ||
                !this.subAssignmentIn.onlyExplanation() ||
                (this.subAssignmentIn.getStatus() && this.subAssignmentIn.getStatus().isInClosedState())
            ) {
                return false;
            }

            return !this.subAssignmentIn.hasStatus() || this.subAssignmentIn.getStatus().isWaitingForSubmit();
        },
    },
};
</script>

<style scoped lang="scss">
.sub-assignments {
    .sub-assignment-page-list {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        .sub-assignment-explanation:not(:last-child),
        .sub-assignment:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
        }
    }
}

.sub-assignments-submit {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');

    .btn-hand-in-sub-assignment {
        width: 100%;
    }
}
</style>
